<template lang="pug">
  WtEntityTable.program-teams-table(
    title="All Public Program Teams"
    has-large-title
    :data="_.get(teamsResponseObject, 'data', [])"
    :pagination-object="teamsResponseObject.pagination"
    :fetch-action="fetchAction"
    default-sort-field="name"
    enable-search
    searchPlaceholder="Search by team name..."
    @search="$emit('search', $event)"
    empty-message="No public teams. Create a new team!"
  )
    BTableColumn(field="name" label="Team Name" sortable v-slot="column")
      WtRouterLink(
        to="Team"
        :params="{ teamId: column.row.teamNameURL}"
        :text="column.row.name"
        type="table"
      )
    BTableColumn(field="numMembers" label="Member Size" centered v-slot="column")
      | {{ column.row.numMembers }} / {{ column.row.maxMembers }}
    BTableColumn(field="type" label="Type" centered v-slot="column")
      | {{ column.row.inviteOnly ? "Public/Invite Only" : "Public/Open" }}
    BTableColumn(
      v-if="coreProgramMeta.memberCanManageTeams"
      field="joined"
      label="Joined"
      v-slot="column"
      centered
    )
      RouterLink(
        :to="{ name: 'Team', params: { teamId: column.row.teamNameURL } }"
      )
        WtJoinButton(:team="column.row")
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import WtRouterLink from "@@/WtRouterLink/WtRouterLink";
import WtEntityTable from "@@/WtEntityTable/WtEntityTable";
import WtJoinButton from "@@/WtJoinButton/WtJoinButton";

export default {
  name: "ProgramTeamsTable",

  components: { WtRouterLink, WtEntityTable, WtJoinButton },

  props: {
    teamsResponseObject: {
      type: Object,
      required: true
    },

    fetchAction: {
      type: Function,
      required: true
    }
  },

  computed: {
    ...mapGetters("program", ["programTeamsResponseObject", "coreProgramMeta"]),
    ...mapGetters("members", ["memberTeamInvites"])
  },

  methods: {
    ...mapActions("program", ["fetchProgramTeams"]),

    isPublic(team) {
      return team.public === true;
    },

    isInvited(team) {
      const memberTeamInviteIds = this.memberTeamInvites.map(
        invite => invite.inviteId
      );

      return memberTeamInviteIds.includes(team.id) || team.isAdmin;
    },

    isValid(team) {
      return (
        this.isPublic(team) || (!this.isPublic(team) && this.isInvited(team))
      );
    }
  }
};
</script>

<style lang="sass" scoped></style>
